import { Message } from "../types";

export function makeMessages<T extends { [name: string]: Message }>(
  messages: T
) {
  return messages;
}
